import * as React from 'react'
import { TEAM_MEMBER_PANE_TAB } from '../../state/constants/index'
import TabBar from '../ui/entity/EntityTabBar'
import TabBarItem from '../ui/entity/EntityTabBarItem'
import UIMessages from 'src/utils/ui-messages'

export interface TeamMemberPaneHeaderProps {
  currentTab: string
  changeTab: (tab: string) => void
}

export interface TeamMemberPaneHeaderState {
  tab: string
}

class TeamMemberPaneHeader extends React.Component<TeamMemberPaneHeaderProps, TeamMemberPaneHeaderState> {
  constructor(props: TeamMemberPaneHeaderProps) {
    super(props)
    this.state = {
      tab: TEAM_MEMBER_PANE_TAB.PERSONAL_INFO
    }
  }

  public handleChangeTab = (activeTab: string) => {
    this.setState({ tab: activeTab })
    this.props.changeTab(activeTab)
  }

  public render() {
    const { currentTab } = this.props
    const { permission, personalInfo } = UIMessages.teamMember

    return (
      <TabBar>
        <TabBarItem active={currentTab === TEAM_MEMBER_PANE_TAB.PERSONAL_INFO}>
          <div onClick={() => this.handleChangeTab(TEAM_MEMBER_PANE_TAB.PERSONAL_INFO)}>{personalInfo}</div>
        </TabBarItem>
        <TabBarItem active={currentTab === TEAM_MEMBER_PANE_TAB.PERMISSION}>
          <div onClick={() => this.handleChangeTab(TEAM_MEMBER_PANE_TAB.PERMISSION)}>{permission}</div>
        </TabBarItem>
      </TabBar>
    )
  }
}

export default TeamMemberPaneHeader



// WEBPACK FOOTER //
// ./src/components/team-members/TeamMemberPaneHeader.tsx